<div>
  <div class="container-fluid gestion-container">
    <header>
      <h2 class="mb-2"><strong> Banner </strong></h2>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item hyperlink">
            <p (click)="changeView('home')"> Inicio </p>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> Configuración del carrusel </li>
        </ol>
      </nav>
    </header>

    <form [formGroup]="carruselForm"
      (ngSubmit)="editingBanner
        ? updateBanner(props.bannerType == 5 ? createdBannerFunciones : createdBanner, onDateNotAllowed)
        : generateBanner(props.bannerType == 5 ? createdBannerFunciones : createdBanner, onDateNotAllowed)"
    >
      <div class="row w-100 match-height-row flex-nowrap g-3">
        <div class="col-5 d-flex">
          <!-- CARD 1 -->
          <div class="card main-card w-100">
            <div class="card-body mt-2">
              <h6 class="mb-4"><strong> Configuración general </strong> </h6>
              <div class="col-12 row mt-4">
                <label class="control-label"> Nombre </label>
                <input type="text" class="form-control input-form" (keyup)="onKey($event)" maxlength="50"
                  formControlName="nombre" />
              </div>
              <div class="count-div d-flex justify-content-end">
                <div class="count-text">{{carruselForm.value.nombre.length}}/50</div>
              </div>
              <div class="col-12 mt-4">
                <label class="control-label"> Imagen </label>

                <!-- CLIP INPUT FILE -->
                <div class="col-12 file-box">
                  <div class="form-group" style="margin-bottom: 0px;">
                    <label for="fileUpload" class="btn btn-white w-100 label-file">
                      {{ iconName || "Selecciona un archivo" }}
                      <mat-icon class="icon-c-folder icon-display" style="color: #000000;"> attach_file </mat-icon>
                    </label>

                    <input #file type="file" id="fileUpload" style="display: none"
                      accept=".png, .jpg, .jpeg, .PNG, .JPG, .JPEG" (change)="loadImage($event)"
                      formControlName="imagen" />
                  </div>
                </div>
              </div>
              <div class="instructions mt-2 mb-4">
                <small> Formato JPG, PNG y JPEG. El peso debe ser menor a 15MB. Las medidas deben ser {{width_valid_icon}} px por {{height_valid_icon}} px.</small>
              </div>
              <!-- <img class="img-fluid tag-empty-icon" src="https://s3.amazonaws.com/dev.structure.files/assets/zeus-front-carrusel/noData.png">  -->
              <div class="banner-preview">
                <div class="banner-preview__wrapper-text row g-0">
                  <div class="banner-preview__text col-8">
                    <small> {{ carruselForm.value.nombre }} </small>
                  </div>
                </div>
                <div class="banner-preview__wrapper-image">
                  <img class="banner-preview__image" [src]="url_preview_icon" [alt]="carruselForm.value.nombre"
                    *ngIf="url_preview_icon">
                </div>
              </div>
              <div class="instructions mt-1 text-center mb-4">
                <small> Imagen ilustrativa del resultado </small>
              </div>
              <!-- DATE PICKER -->
              <div class="row mt-4 footer-card">
                <div class="col-6 mt-2">
                  <div class="form-group">
                    <label> Vigencia desde </label>
                    <input formControlName="dateInit" placeholder="dd/mm/aaaa" class="form-control"
                      [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1">
                    <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <div class="form-group">
                    <label> Vigencia hasta </label>
                    <input formControlName="dateEnd" placeholder="dd/mm/aaaa" class="form-control"
                      [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2">
                    <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                  </div>
                </div>
                <div class="col-6 mt-4">
                  <div class="form-group">
                    <label> Hora inicio </label>
                    <select class="form-control" formControlName="timeInit">
                      <option value="" selected disabled>Hora inicio</option>
                      <option *ngFor="let opt of timePickerList" [value]="opt">
                        {{ opt }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-6 mt-4">
                  <div class="form-group">
                    <label> Hora fin </label>
                    <select class="form-control" formControlName="timeEnd">
                      <option value="" selected disabled>Hora fin</option>
                      <option *ngFor="let opt of timePickerList" [value]="opt">
                        {{ opt }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-7 d-flex flex-column right-scroll-column">
          <!-- CARD 2 -->
          <div *ngIf="props.bannerType != 5"  class="card card-style mb-3 flex-shrink-0 card-margin">
            <div class="card-body">
              <h6 class="mb-4"><strong> Destino </strong> </h6>
              <div class="row col-12 mb-3 mt-3">
                <div class="col-6">
                  <label for="name">Tipo de destino</label>
                  <select class="form-select" (change)="optionSelected($event.target.value)">
                    <option *ngFor="let opt of dropdownArray" [value]="opt.idTipoLink"
                      [selected]="opt.selected == true">
                      {{ opt.tipoLink }}
                    </option>
                  </select>
                </div>
                <div class="col-6">
                  <label class="control-label"> {{ instructions }}</label>
                  <input type="text" class="form-control" formControlName="urlLink" *ngIf="dropdownValue != '3'" />
                  <select class="form-select form-control" formControlName="urlLink" *ngIf="dropdownValue == '3'">
                    <option value="" selected disabled> Seleccionar </option>
                    <option *ngFor="let item of enlacesZeus" [ngValue]="item.enlace"> {{item.nombre}} </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- CARD 3 -->
          <div 
            class="card card-style card-margin" 
            [ngClass]="{
              'flex-grow-1': carruselForm.get('segmentation')?.value == false, 
              'flex-grow-0 align-self-start w-100': carruselForm.get('segmentation')?.value == true
            }" 
            style="margin-bottom: 8px;">
            <div class="card-body">
              <h6 class="mb-4"><strong> Audiencia </strong> </h6>
              <div class="row col-12 mb-1 mt-3">
                <p> ¿Este banner lo debe visualizar todo Red Grupo Elektra? </p>
                <p class="control-label">
                  No &nbsp;&nbsp;
                  <ui-switch color="#5FC45B" size="small" formControlName="segmentation"
                    (change)="onChangeSegmentation($event)">
                  </ui-switch>
                  &nbsp;&nbsp;Sí
                </p>
              </div>
              <div class="row col-12" *ngIf="!udnSegmentation">
                <div class="col-6">
                  <small>
                    Descarga el formato excel y llena las casillas con la información de
                    la audiencia a la que va dirigido el banner.
                  </small>
                  <div class="col-8 offset-md-2 p-3">
                    <button type="button" class="btn text-white btn-template"
                      (click)="$event.preventDefault(); downloadFile('Carga_empleados')">
                      <mat-icon class="icon-c-folder icon-display-button" svgIcon="icon-download"></mat-icon>
                      Descargar formato
                    </button>
                  </div>
                  <div class="mb-3">
                    <small>
                      Una vez listo, súbelo y revisa que todo esté correcto.
                    </small>
                  </div>

                  <!-- DROPZONE SEGMENTACION-->
                  <app-drop-zone (employeesArrayList)="employeesArrayList = $event"
                    (onUpdateSegmentation)="onUpdateSegmentation = $event" [fileName]="fileName"
                    [editingBanner]="editingBanner">
                  </app-drop-zone>
                </div>

                <div class="col-6" style="padding-left: 0px;">
                  <div class="card custom-inner-card">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <div class="navigator-tab">
                        <li class="nav-item" role="presentation">
                          <button class="nav-link tab-button active" id="home-tab" data-bs-toggle="tab"
                            data-bs-target="#visita-efectiva" type="button" role="tab" aria-controls="home"
                            aria-selected="true" (click)="onChangeTable(true)">
                            <small *ngIf="employeesArrayList.allowed === undefined"> Audiencia </small>
                            <small *ngIf="employeesArrayList.allowed"> Audiencia ({{employeesArrayList.allowed.length}})
                            </small>
                          </button>
                        </li>
                      </div>
                      <div class="navigator-tab">
                        <li class="nav-item" role="presentation">
                          <button class="nav-link tab-button" id="profile-tab" data-bs-toggle="tab" type="button"
                            role="tab" aria-controls="profile" aria-selected="false" (click)="onChangeTable(false)">
                            <small *ngIf="employeesArrayList.allowed === undefined"> No encontrados</small>
                            <small *ngIf="employeesArrayList.notAllowed"> No encontrados
                              ({{employeesArrayList.notAllowed.length}})</small>
                          </button>
                        </li>
                      </div>
                    </ul>
                    <div class="card-body" style="overflow: auto; height: 350px;">
                      <div class="row">
                        <!-- EXCEL VALIDATOR COMPONENT -->
                        <div>
                          <app-validate-component [employeesArrayList]="employeesArrayList"
                            [showAllowedEmployees]="showAllowedEmployees">
                          </app-validate-component>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Card Funciones-->
          <div *ngIf="props.bannerType == 5" class="col-12 card mt-4 card-style">
            <app-attachment-function-component
              [existingAttachments]="existingAttachments"
              (attachmentsReady)="onAttachmentsReady($event)"
              [idBanner]="editingBanner ? onEditApiData.idBanner : null">
            </app-attachment-function-component>
            <span class="nota-guardar" *ngIf="props.bannerType == 5">El boton guardar solo afectara la pestaña seleccionada (Carga funcioines, Carga masiva o Carga número empleado), si realizo multiples cargas debera pulsar guardar en cada una de las cargas.</span>
          </div>
        </div>
      </div>
      <div class="pt-2 col-12 d-flex justify-content-end mt-3 footer-pr">
        <!-- FOOTER -->
        <button type="button" class="btn btn-cancelar" (click)="changeView('home')">
          <strong style="padding-right: 5px;">Cancelar</strong>
        </button>
        <button type="submit" class="btn btn-acept" [disabled]="!carruselForm.valid">
          <strong style="padding-right: 5px;">{{ saveButtonLabel }}</strong>
        </button>
      </div>
    </form>
  </div>

  <!-- MODAL CONFIRMACION BANNER CREADO -->
  <ng-template #createdBanner let-modal>
    <div class="card-alert">
      <!-- Imagen -->
      <div class="col-6 offset-3 mt-4 confirmation text-center">
        <img class="circular--square" src="https://s3.amazonaws.com/dev.structure.files/assets/creado.png" />
      </div>
      <div class="col-8 offset-2">
        <h4 class="card-alert-header alert-title"> Éxito </h4>
      </div>
      <div class="col-md-8 offset-md-2">
        <p class="text-center alert-body mt-1">
          ¡Tu banner ha sido configurado con éxito!
        </p>
      </div>
      <div class="modal-footer mt-3 mb-3">
        <div class="col-8">
          <button type="button" class="btn-acept-modal" (click)="modal.close('Close click'); changeView('home')">
            Aceptar </button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- MODAL CONFIRMACION BANNER FUNCIONES (tipo 5) -->
  <ng-template #createdBannerFunciones let-modal>
    <div class="card-alert">
      <!-- Imagen -->
      <div class="col-6 offset-3 mt-4 confirmation text-center">
        <img class="circular--square" src="https://s3.amazonaws.com/dev.structure.files/assets/creado.png" />
      </div>
      <div class="col-8 offset-2">
        <h4 class="card-alert-header alert-title"> Éxito </h4>
      </div>
      <div class="col-md-8 offset-md-2">
        <p class="text-center alert-body mt-1">
          Sección guardada con éxito. ¿Deseas continuar configurando el banner?
        </p>
      </div>
      <div class="modal-footer mt-3 mb-3 d-flex justify-content-center gap-2">
        <button type="button" class="btn btn-cancelar" (click)="modal.close('Close click')">
          <strong>Continuar configurando</strong>
        </button>
        <button type="button" class="btn-acept-modal" (click)="modal.close('Close click'); changeView('home')">
          <strong>Finalizar</strong>
        </button>
      </div>
    </div>
  </ng-template>

  <!-- FECHA NO DISPONIBLE -->
  <ng-template #onDateNotAllowed let-modal>
    <div class="card-alert">
      <h5 class="card-alert-header mt-4 text-center"> Fecha no disponible </h5>
      <div class="card-alert-body col-12">
        <p> Intenta con una nueva fecha y hora, por favor. </p>
      </div>
      <hr>
      <div class="footer mb-4">
        <div class="mt-3">
          <button type="button" class="btn form-button border-transparent"
            (click)="modal.close('Close click')">Aceptar</button>
        </div>
      </div>
    </div>
  </ng-template>

</div>